const homeAudiencesPath = '/app/audiences';
const homeOrganizationsPath = '/app/organizations';
const homePath = '/app/dashboard';
const conversationsPath = '/app/conversations';

// Matches audience/organization detail pages (but not the create-segment sub-route).
const detailsPageRegex = /^\/app\/(organizations|audiences)\/[0-9]*\/(?!create-segment)/;
const isDetailsPagePath = (pathname: string) => detailsPageRegex.test(pathname);

// Matches anything scoped to a single audience: its tabs, the create-segment sub-route and the
// person deep link. Used to know when the user leaves the audience detail context entirely.
const audienceDetailsRegex = /^\/app\/audiences\/[0-9]+/;
const isAudienceDetailsPath = (pathname: string) => audienceDetailsRegex.test(pathname);

export {
  conversationsPath,
  homeAudiencesPath,
  homeOrganizationsPath,
  homePath,
  isAudienceDetailsPath,
  isDetailsPagePath,
};
